module.exports = __webpack_public_path__ + "f142c9265f4e9597dccaa585c3ce1269.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-writing-skills.png
// module id = 1747
// module chunks = 0